/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Feat1_BodyInputs */

const es_l6_feat1_body = /** @type {(inputs: L6_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La comisión más baja de la categoría. Lo que ganas con cada reserva es tuyo.`)
};

const gl_l6_feat1_body = /** @type {(inputs: L6_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A comisión máis baixa da categoría. O que gañas con cada reserva é teu.`)
};

const en_l6_feat1_body = /** @type {(inputs: L6_Feat1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The lowest commission in the category. What you earn on each booking is yours.`)
};

/**
* | output |
* | --- |
* | "The lowest commission in the category. What you earn on each booking is yours." |
*
* @param {L6_Feat1_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_feat1_body = /** @type {((inputs?: L6_Feat1_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Feat1_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_feat1_body(inputs)
	if (locale === "en") return en_l6_feat1_body(inputs)
	return es_l6_feat1_body(inputs)
});